import "./style.css";
import { defineComponent as t, defineAsyncComponent as n, resolveComponent as r, openBlock as p, createBlock as c } from "vue";
import { k as s, f as l } from "./index-buEOnV4i.js";
const i = () => import("./index-buEOnV4i.js").then((o) => o.H).then((o) => o.default).catch((o) => {
  throw console.error(
    "Error while attempting to dynamically import component Block at ../block.vue",
    o
  ), o;
}), m = t({
  name: "repeated-block",
  components: { Block: n(i) },
  props: ["repeatContext", "block", "registeredComponents", "linkComponent"],
  data() {
    return { store: this.repeatContext };
  },
  provide() {
    const o = this;
    return {
      [s.key]: o.store
    };
  }
});
function a(o, k, d, C, f, u) {
  const e = r("block");
  return p(), c(e, {
    block: o.block,
    context: o.store,
    registeredComponents: o.registeredComponents,
    linkComponent: o.linkComponent
  }, null, 8, ["block", "context", "registeredComponents", "linkComponent"]);
}
const _ = /* @__PURE__ */ l(m, [["render", a]]);
export {
  _ as default
};
